import { render, staticRenderFns } from "./linearea.vue?vue&type=template&id=5b8215d7&scoped=true&"
import script from "./linearea.vue?vue&type=script&lang=js&"
export * from "./linearea.vue?vue&type=script&lang=js&"
import style0 from "./linearea.vue?vue&type=style&index=0&id=5b8215d7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8215d7",
  null
  
)

export default component.exports